import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const features = [
  { title: 'Innovation First', description: 'We constantly explore new technologies to build modern, efficient solutions.', icon: 'Zap', color: 'text-amber-500', bg: 'bg-amber-50' },
  { title: 'Reliable Infrastructure', description: 'Built on robust cloud architecture ensuring maximum uptime and performance.', icon: 'Server', color: 'text-blue-500', bg: 'bg-blue-50' },
  { title: 'Massively Scalable', description: 'Our products are designed to handle millions of requests seamlessly.', icon: 'TrendingUp', color: 'text-emerald-500', bg: 'bg-emerald-50' },
  { title: 'Customer Centric', description: 'Every feature we build is driven by real user needs and feedback.', icon: 'Heart', color: 'text-rose-500', bg: 'bg-rose-50' },
];

const Features = () => {
  return (
    <section className="py-24 bg-white border-y border-slate-200">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">Why Choose Digital Ways</h2>
          <p className="text-slate-600 text-lg">The core principles that drive our product development.</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="p-8 rounded-3xl bg-slate-50 border border-slate-100 hover:border-slate-300 hover:shadow-lg hover:shadow-slate-200/50 transition-all group"
            >
              <div className={`w-14 h-14 rounded-2xl ${feature.bg} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <SafeIcon name={feature.icon} className={`text-2xl ${feature.color}`} />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;